module.exports = __webpack_public_path__ + "img/logo-2.72142f8f.webp";